export type BankValidationDetail = {
  errors?: {
    __all__?: string[];
    [field: string]: string[] | undefined;
  };
  customers?: Array<{
    id: string;
    errors?: {
      children?: string[];
      [field: string]: string[] | undefined;
    };
  }>;
  id?: number;
  bank?: string;
};

export function getBankDocumentErrorMessage(res: { _message?: string; _detail?: unknown } | null) {
  const detail = res?._detail as BankValidationDetail | undefined;
  const allErrors = detail?.errors?.__all__;
  const customers = detail?.customers;

  if (Array.isArray(allErrors) && allErrors.length) {
    return [res?._message, ...allErrors].filter(Boolean).join('\n');
  }

  if (customers?.length) {
    const customerErrors = customers.flatMap(customer => customer?.errors?.children ?? []);

    if (customerErrors.length) {
      return [res?._message, ...customerErrors].filter(Boolean).join('\n');
    }
  }

  return res?._message;
}
